
(() => {
  const root = document.getElementById('MainContent');
  if (!root) return;
  let pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; align(); });
  }
  function align() {
    const cards = [...root.querySelectorAll('.product-card-wrapper > .card:not(.card--horizontal)')]
      .filter(card => card.getBoundingClientRect().width && card.closest('.grid'));
    const groups = new Map();
    for (const card of cards) {
      const title = card.querySelector(':scope > .card__content > .card__information > .card__heading');
      const price = card.querySelector(':scope > .card__content > .card__information .price');
      if (!title || !price) continue;
      title.style.minHeight = '';
      price.style.marginTop = '';
      const grid = card.closest('.grid');
      if (!groups.has(grid)) groups.set(grid, new Map());
      const item = card.closest('.grid__item');
      const top = item ? item.offsetTop : card.offsetTop;
      const rows = groups.get(grid);
      if (!rows.has(top)) rows.set(top, []);
      rows.get(top).push({ card, title, price });
    }
    for (const rows of groups.values()) {
      for (const row of rows.values()) {
        const titleHeight = Math.max(...row.map(item => item.title.getBoundingClientRect().height));
        for (const item of row) item.title.style.minHeight = titleHeight + 'px';
      }
    }
    for (const rows of groups.values()) {
      for (const row of rows.values()) {
        const measurements = row.map(item => ({
          item,
          offset: item.price.getBoundingClientRect().top - item.card.getBoundingClientRect().top,
          margin: parseFloat(getComputedStyle(item.price).marginTop) || 0
        }));
        const target = Math.max(...measurements.map(value => value.offset));
        for (const value of measurements) {
          value.item.price.style.marginTop = (value.margin + target - value.offset) + 'px';
        }
      }
    }
  }
  let width = 0;
  new ResizeObserver(entries => {
    const next = entries[0].contentRect.width;
    if (next !== width) { width = next; schedule(); }
  }).observe(root);
  new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', schedule);
  root.addEventListener('load', schedule, true);
  if (document.fonts) document.fonts.ready.then(schedule);
  schedule();
})();
